var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_394_727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.375 7.1875H8.625V8.4375H7.375V7.1875Z",
    fill: "#004276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.125 1.25H13.375V0H12.125V1.25H3.875V0H2.625V1.25H1.875C0.841125 1.25 0 2.09113 0 3.125V14.125C0 15.1589 0.841125 16 1.875 16H8.30506C7.87208 15.6425 7.49625 15.221 7.19059 14.75H1.875C1.53038 14.75 1.25 14.4696 1.25 14.125V5.875H14.75V7.19059C15.221 7.49627 15.6425 7.87209 16 8.30506V3.125C16 2.09113 15.1589 1.25 14.125 1.25ZM14.75 4.625H1.25V3.125C1.25 2.78038 1.53038 2.5 1.875 2.5H2.625V3.75H3.875V2.5H12.125V3.75H13.375V2.5H14.125C14.4696 2.5 14.75 2.78038 14.75 3.125V4.625Z",
    fill: "#004276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7812 7.5625C9.45503 7.5625 7.5625 9.45503 7.5625 11.7812C7.5625 14.1075 9.45503 16 11.7812 16C14.1075 16 16 14.1075 16 11.7812C16 9.45503 14.1075 7.5625 11.7812 7.5625ZM11.7812 14.75C10.1443 14.75 8.8125 13.4182 8.8125 11.7812C8.8125 10.1443 10.1443 8.8125 11.7812 8.8125C13.4182 8.8125 14.75 10.1443 14.75 11.7812C14.75 13.4182 13.4182 14.75 11.7812 14.75Z",
    fill: "#004276"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.375 9.6875H11.125V12.4062H13.4375V11.1562H12.375V9.6875ZM4.875 9.6875H6.125V10.9375H4.875V9.6875ZM2.375 9.6875H3.625V10.9375H2.375V9.6875ZM2.375 7.1875H3.625V8.4375H2.375V7.1875ZM2.375 12.1875H3.625V13.4375H2.375V12.1875ZM4.875 7.1875H6.125V8.4375H4.875V7.1875ZM4.875 12.1875H6.125V13.4375H4.875V12.1875Z",
    fill: "#004276"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_394_727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateicon);
export default __webpack_public_path__ + "static/media/dateicon.43be1f6936ae46df52fc4f282ef9f495.svg";
export { ForwardRef as ReactComponent };